import { useState } from "react";
import { StoreProductCardtype } from "../type";
import { Modal } from "antd";
import BuyProductPopUp from "./buyProductPopUp";
import { useTranslation } from "react-i18next";

const codeColor = [
    { name: 'mt4', color: 'bg-blue-500' },
    { name: 'mt5', color: 'bg-green-500' },
    { name: 'cTrader', color: 'bg-purple-500' },
    { name: 'all', color: 'bg-yellow-500' },
]

interface StoreProductCardProps extends StoreProductCardtype {
    key?: number;
    isPurchased?: boolean;
    fileBot?: string;
}

const StoreProductCard: React.FC<StoreProductCardProps> = (props) => {
    const [isBuyOpen, setIsBuyOpen] = useState(false);
    const { t } = useTranslation();
    const theme = localStorage.getItem('theme');
    const handleViewOrBuy = () => {

        if (props.isPurchased) {
            if (props.id === 283 || props.id === 286) {
                window.location.href = `/stores/view/${props.id}`;
            } else if (props.fileBot) {
                const link = document.createElement('a');
                link.href = props.fileBot;
                link.download = `${props.name.replace(/[^a-z0-9]/gi, '_')}.zip`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                console.log('No file available for download');
            }
        }
        else if (props.finalPrice === "$0") {
            // For free products, directly open the buy modal
            setIsBuyOpen(true);
        }
        else {
            setIsBuyOpen(true);
        }
    };

    const isPurchased = props.isPurchased || false;

    return (
        <div className={`product-card flex flex-col rounded-[4px] !shadow-md hover:!shadow-xl transition-shadow duration-300 overflow-hidden`}>
            <div className={`relative h-120 md:h-80   `}>
                <div className={`absolute inset-0 flex items-center justify-center bg-gray-100 img-loading product-card`}>
                    <img src="/loading.svg" alt="loading" className="w-16 h-16" />
                </div>

                <img    
                    alt={props.name}
                    className={`w-full h-full object-cover product-card`}
                    srcSet={`${props.image}?w=400 400w, ${props.image}?w=800 800w`}
                    sizes="(max-width: 600px) 400px, 800px"
                    style={{ opacity: 0 }}
                    onLoad={e => {
                        const target = e.currentTarget as HTMLImageElement;
                        target.style.transition = 'opacity 300ms ease-in';
                        target.style.opacity = '1';

                        // remove any loading placeholder/overlay if present
                        const placeholder = target.parentElement?.querySelector('.img-loading, .loading-svg, .loading-placeholder') as HTMLElement | null;
                        if (placeholder) placeholder.remove();
                    }}
                    onError={e => {
                        const target = e.currentTarget as HTMLImageElement;
                        // prevent repeated error handling
                        target.onerror = null;
                        // hide the broken image element
                        target.style.display = 'none';

                        // remove any loading placeholder/overlay if present
                        const placeholder = target.parentElement?.querySelector('.img-loading, .loading-svg, .loading-placeholder') as HTMLElement | null;
                        if (placeholder) placeholder.remove();

                        // only add one fallback element
                        if (!target.parentElement?.querySelector('.img-fallback')) {
                            const fallback = document.createElement('div');
                            fallback.className = `img-fallback h-full inset-0 flex items-center justify-center `;
                            fallback.innerHTML = `
                                <div class="flex flex-col items-center  ">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><path d="M104,208H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V88l-48,16-16,40-40,16Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M137.73,208l7.94-23.8,39-15.58,15.58-39,23.8-7.94V200a8,8,0,0,1-8,8Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M32,168.69l54.34-54.35a8,8,0,0,1,11.32,0l39,39" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>    
                                    <p class="mt-2 text-sm text-gray-500">Image not available</p>
                                </div>    
                            `;
                            target.parentNode?.appendChild(fallback);
                        }
                    }}
                />
                {props.indicator && (
                    <div className="absolute z-[10] top-4 left-4 bg-[#E9B460] text-white px-2 py-1 rounded-full text-xs font-semibold">
                        {props.indicator}
                    </div>
                )}
                <div className={`absolute top-4 right-4 text-white px-2 py-1 rounded-full text-xs font-semibold ${codeColor.find(c => c.name === props.platform)?.color || 'bg-gray-500'}`}>
                    🚀 {props.platform[0].toLocaleUpperCase()}{props.platform.slice(1)}
                </div>
            </div>
            <div className={`p-4 flex flex-col justify-between flex-1 max-h-[350px] border-t border-gray-200 product-info`}>
                <div className="">
                    <div className="flex items-start justify-between">
                        <h3 className="!text-2xl line-clamp-2 font-bold text-gray-900">{props.name}</h3>
                        {/* <div className="flex items-center gap-1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-star h-4 w-4 text-yellow-400 fill-current"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
                            <span className="!text-sm font-medium">{props.star}</span>
                            <span className="!text-xs text-gray-500">({props.review})</span>
                        </div> */}
                    </div>
                    <p className="text-gray-600 !text-sm mb-0 line-clamp-4 lg:line-clamp-2 ">{props.description}</p>
                </div>
                <div className="flex flex-col product-text">
                    <div className="flex items-center justify-between mb-4">
                        {props.finalPrice !== "$null" &&
                            (
                                <div className="flex items-center gap-2">
                                    <span className="text-2xl font-bold product-text">
                                        {
                                            props.finalPrice == "$0" ? t('store_free') : `${props.finalPrice} USD`
                                        }
                                    </span>
                                    {props.discount && (
                                        <span className="text-sm text-gray-500 line-through">{props.price}</span>
                                    )}
                                </div>
                            )
                        }
                    </div>
                    <div className="flex flex-col lg:flex-row gap-2 btn-product-text">
                        <button
                            onClick={() => window.location.href = `/stores/${props.id}`}
                            className="button-detail flex-1 flex items-center justify-center gap-2 bg-gray-100 text-gray-700 px-2 py-2 !rounded-[3px] hover:bg-gray-300 transition duration-300">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-eye h-4 w-4"><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                            {t('store_detail')}
                        </button>
                        <button
                            onClick={handleViewOrBuy}
                            className={`flex-1 flex items-center justify-center gap-2 px-2 py-2 !rounded-[3px] transition duration-300 ${isPurchased ? 'bg-green-500 text-white hover:bg-green-600' : 'bg-[#E9B460] text-white hover:bg-[#e7a234]'}`}>
                            {isPurchased ? (
                                (props.id === 283 || props.id === 286) ? (
                                    <>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-eye h-4 w-4"><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                                        {t('store_view') || 'View'}
                                    </>
                                ) : (
                                    <>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-download h-4 w-4"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
                                        {t('store_download') || 'Download'}
                                    </>
                                )
                            ) : (
                                <>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-shopping-cart h-4 w-4"><circle cx="8" cy="21" r="1"></circle><circle cx="19" cy="21" r="1"></circle><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"></path></svg>
                                    {t('store_buyNow')}
                                </>
                            )}
                        </button>
                        <Modal
                            title={
                                <div className="modal-header flex flex-col px-6 pt-4 rounded items-start bg-gradient-to-r from-blue-50 to-indigo-50">
                                    <h2 className="!text-2xl font-bold text-gray-900 !mb-0">{t('store_checkoutTitle')}</h2>
                                    <p className="text-gray-600">{t('store_checkoutDesc')}</p>
                                </div>
                            }
                            styles={{
                                header: {
                                    padding: 0,
                                },
                                content: {
                                    padding: 0,
                                },
                                body: {
                                    padding: 8,
                                }
                            }}
                            style={{
                                top: 20,
                            }}
                            open={isBuyOpen}
                            onCancel={() => setIsBuyOpen(false)}
                            footer={null}
                            width={600}
                        >
                            <BuyProductPopUp
                                id={props.id}
                                name={props.name}
                                finalPrice={props.finalPrice}
                                price={props.price}
                                image={props.image}
                                description={props.description}
                                indicator={props.indicator}
                                platform={props.platform}
                                star={props.star}
                                review={props.review}
                                onClose={() => setIsBuyOpen(false)}
                            />
                        </Modal>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default StoreProductCard;